module.exports = __webpack_public_path__ + "img/zadania_inactive.2d21c234.svg";